export const AdminRequest = {
    path: '/admin_requests',
    name: 'admin_requests',
    component: () => import('@/views/Request/Claim/AdminRequestPage.vue'),
    children: [
        {
            path: '/admin_requests/add',
            name: 'admin_requests.add',
            component: () => import('@/views/Request/Claim/Form/AdminRequestForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/admin_requests/edit/:id',
            name: 'admin_requests.edit',
            component: () => import('@/views/Request/Claim/Form/AdminRequestForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/admin_requests/delete/:id',
            name: 'admin_requests.delete',
            component: () => import('@/views/Request/Claim/Form/AdminRequestForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/admin_requests/view/:id',
            name: 'admin_requests.view',
            component: () => import('@/views/Request/Claim/Form/AdminRequestForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/admin_requests/set_decision/:id/:module',
            name: 'admin_requests.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
            props: {module: "ADMIN_REQUEST"}
        },
        {
            path: '/admin_requests/take_in_charge/:id/:module',
            name: 'admin_requests.take_in_charge',
            component: () => import('@/views/Request/Components/TakeInCharge.vue'),
        },
        {
            path: '/admin_requests/timelines/:id',
            name: 'admin_requests.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
            props: {module: "ADMIN_REQUEST"}
        },
        {
            path: '/admin_requests/documents/:id',
            name: 'admin_requests.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "ADMIN_REQUEST"}
        },
    ],
}